export default __webpack_public_path__ + "static/media/pakkapati 2.ab60918c.PNG";